import React from 'react';
import { isHostSelectSignup } from '../../utils/signupSelection';

const HostSelectBadge = ({ session, className = '' }) => {
  if (!isHostSelectSignup(session)) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border border-primary/25 bg-primary/5 px-2 py-0.5 text-xs font-medium text-primary ${className}`}
      title="You choose who is confirmed from the signup list"
    >
      <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.75}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
        />
      </svg>
      Host selects
    </span>
  );
};

export default HostSelectBadge;
